import { COMMON } from './localizations';

/**
 * @name updateTitle
 * @function
 * @description Updates the page title 
 * @param {string} [title] Title to update with
 */
export const updateTitle = title => {
    var str = COMMON.appName;
    if( title ) str = `${ title } - ${ str }`;
    document.title = str;
}